import { Quill } from 'react-quill-new';

// Get the Block Embed from Quill
const BlockEmbed = Quill.import('blots/block/embed');

/**
 * DividerBlot - Custom Quill blot for horizontal rules (<hr>)
 */
class DividerBlot extends BlockEmbed {
  static blotName = 'divider';
  static tagName = 'hr';
  
  static create() {
    const node = super.create();
    return node;
  }
  
  static value() {
    return true;
  }
}

// Register the custom blot
Quill.register(DividerBlot, true);

export { DividerBlot };
